<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 评级数据统计列表
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="handle-box">
				<!-- <el-select v-model="bill" placeholder="请选择评级订单" clearable>
					<el-option v-for="item in billList" :key="item.Id" :label="item.Name" :value="item.Id">
					</el-option>
				</el-select> -->
				<el-input placeholder="商品标签码" class="handle-input mr10" v-model="QRFont" clearable></el-input>
				<el-select v-model="seriesId" placeholder="请选择系列" clearable>
					<el-option v-for="item in serList" :key="item.Id" :label="item.Name" :value="item.Id">
					</el-option>
				</el-select>
				<el-select v-model="categoryId" placeholder="请选择分类" clearable>
					<el-option v-for="item in catList" :key="item.Id" :label="item.Name" :value="item.Id">
					</el-option>
				</el-select>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
			</div>
			<el-table :data="goodsList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				style="width: 100%">
				<el-table-column prop="QRFont" label="商品标签码" align="center" min-width="200"></el-table-column>
				<el-table-column prop="Name" label="商品名称" align="center" min-width="200"></el-table-column>
				<!-- <el-table-column prop="Id" label="商品ID" align="center" min-width="300"></el-table-column> -->
				<el-table-column prop="SeriesName" label="系列名称" align="center" min-width="100"></el-table-column>
				<el-table-column prop="CategoryName" label="分类名称" align="center" min-width="100"></el-table-column>
				<el-table-column prop="isStar" label="是否带星" align="center" min-width="100"></el-table-column>
				<el-table-column prop="Surface" label="Surface" align="center" min-width="100"></el-table-column>
				<el-table-column prop="Edges" label="Edges" align="center" min-width="100"></el-table-column>
				<el-table-column prop="Corners" label="Corners" align="center" min-width="100"></el-table-column>
				<el-table-column prop="Centering" label="Centering" align="center" min-width="100"></el-table-column>
				<el-table-column prop="LastScore" label="总分" align="center" min-width="100"></el-table-column>
				<el-table-column fixed="right" label="操作" width="100" align="center">
					<template #default="scope">
						<el-button @click="handleClick(scope.row)" type="text">查看</el-button>
						<!-- <el-button type="text" icon="el-icon-picture" @click="lookPhoto(scope.row)">查看商品照片</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="pageIndex"
					:page-size="pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
			</div>


			<!-- 照片弹出框-->
			<el-dialog :title="title" v-model="isphoto" width="30%">
				<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules"
					style="display: flex;justify-content: center;">
					<div class="listPhoto">
						<!-- <div style="width: 45%; height: 350px" v-for="(fit,index) in photoList" :key="fit">
							<h3 style="text-align: center;">{{index==0?'正面':'反面'}}</h3><br>
							<el-image style="width: 100%; height: 300px" :src="fit.Url"
								v-show="photoList==''?false:true">
							</el-image>
						</div> -->
						<!-- <button type="button" @click="updataGoodsImg(fit)">修改</button> -->
						<div style="width: 45%; height: 300px;background-color: #eee;">
							<h3 style="text-align: center;">正面</h3><br>
							<div
								style="width: 100%; height: 300px;background-color: #eee;display: flex;justify-content: center;align-items: center;">
								<el-image style="width: 100%; height: 300px" :src="photoList1.Url"
									v-show="photoList1==''?false:true">
								</el-image>
								<span v-show="photoList1==''?true:false">无照片</span>
							</div>
							<el-upload action :before-upload="beforeAvatarUpload1" :on-exceed="handleExceed"
								style="margin-left: 80px;margin-top: 20px;">
								<el-button size="small" type="primary" id="show">{{title1}}
								</el-button>
							</el-upload>
						</div>
						<div style="width: 45%; height: 300px;background-color: #eee;">
							<h3 style="text-align: center;">反面</h3><br>
							<div
								style="width: 100%; height: 300px;background-color: #eee;display: flex;justify-content: center;align-items: center;">
								<el-image style="width: 100%; height: 300px" :src="photoList2.Url"
									v-show="photoList2==''?false:true">
								</el-image>
								<span v-show="photoList2==''?true:false">无照片</span>
							</div>
							<el-upload action :before-upload="beforeAvatarUpload2" :on-exceed="handleExceed"
								style="margin-left: 80px;margin-top: 20px;">
								<el-button size="small" type="primary" id="show">{{title2}}
								</el-button>
							</el-upload>
						</div>

					</div>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button type="primary" @click='uploadPhoto'>确认上传照片</el-button>
					</span>
				</template>
			</el-dialog>

			<!-- 查看照片 -->
			<el-dialog :title="title" v-model="showphoto" width="30%">
				<el-table :data="photoList" border class="table" ref="multipleTable"
					header-cell-class-name="table-header" style="width: 100%">
					<!-- <el-table-column prop="Id" label="ID" align="center" fixed></el-table-column> -->
					<el-table-column prop="Url" label="图片" align="center" fixed>
						<template #default="scope">
							<el-image class="table-td-thumb" :src="scope.row.Url" :preview-src-list="[scope.row.Url]"
								style="width: 150px; height: 150px;">
							</el-image>
						</template>
					</el-table-column>
					<!-- <el-table-column label="操作" fixed width="100" align="center">
						<template #default="scope">
							<el-button type="danger" icon="el-icon-delete" circle @click='updatePhoto(scope.$index)'>
							</el-button>
						</template>
					</el-table-column> -->
				</el-table>
			</el-dialog>

			<!-- 编辑弹出框 查看弹出框-->
			<el-dialog :title="title" v-model="editVisible" width="30%">
				<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item label="商品标签号" prop="QRFont">
						<el-input v-model="ruleForm.QRFont" disabled></el-input>
					</el-form-item>
					<el-form-item label="商品名称" prop="Name">
						<el-input v-model="ruleForm.Name" disabled></el-input>
					</el-form-item>
					<el-form-item label="商品编码" prop="Code">
						<el-input v-model="ruleForm.Code" disabled></el-input>
					</el-form-item>
					<el-form-item label="系列名称" prop="SeriesName">
						<el-input v-model="ruleForm.SeriesName" disabled></el-input>
					</el-form-item>
					<el-form-item label="PE/CE" prop="PE">
						<el-select v-model="ruleForm.PE" placeholder="PE或者CE" style="width: 100%;"
							:disabled="isdisabled" clearable>
							<el-option :label="item.label" :value="item.value" v-for="item in checkList"
								:key="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="分类名称" prop="CategoryName">
						<el-input v-model="ruleForm.CategoryName" disabled></el-input>
					</el-form-item>
					<el-form-item label="是否带星" prop="isStar">
						<el-input v-model="ruleForm.isStar" disabled></el-input>
					</el-form-item>
					<el-form-item label="Surface" prop="Surface">
						<el-input v-model="ruleForm.Surface" disabled></el-input>
					</el-form-item>
					<el-form-item label="Edges" prop="Edges">
						<el-input v-model="ruleForm.Edges" disabled></el-input>
					</el-form-item>
					<el-form-item label="Corners" prop="Corners">
						<el-input v-model="ruleForm.Corners" disabled></el-input>
					</el-form-item>
					<el-form-item label="Centering" prop="Centering">
						<el-input v-model="ruleForm.Centering" disabled></el-input>
					</el-form-item>
					<el-form-item label="总分" prop="LastScore">
						<el-input v-model="ruleForm.LastScore" disabled></el-input>
					</el-form-item>
					<el-form-item label="商品正面照片" prop="frontPhoto" :class="{'xiaoshi':!ruleForm.frontPhoto}">
						<a target="_blank" :href="ruleForm.frontPhoto">
							<el-image style=" height: 170px;border-radius: 5px;" :src="ruleForm.frontPhoto"
								:preview-src-list="ruleForm"></el-image></a>
					</el-form-item>
					<el-form-item label="商品反面照片" prop="backPhoto" :class="{'xiaoshi':!ruleForm.backPhoto}">
						<a target="_blank" :href="ruleForm.backPhoto">
							<el-image style=" height: 170px;border-radius: 5px;" :src="ruleForm.backPhoto" :preview-src-list="ruleForm">
							</el-image></a>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="editVisible = false">取 消</el-button>
					</span>
				</template>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import qs from 'qs';
	export default {
		data() {
			return {
				checkList: [{
						value: 0,
						label: '无'
					},
					{
						value: 1,
						label: 'PE'
					}, {
						value: 2,
						label: 'CE'
					}, {
						value: 3,
						label: 'PE,CE'
					},
				],
				seriesId: '',
				categoryId: '',
				QRFont: '',
				title1: '',
				title2: '',
				OrderCode: '', //订单编码
				goodsName: '',
				showphoto: false,
				code: '', //商品编号
				pingjiList: [],
				title: '',
				goodsList: [],
				billList: [],
				ruleForm: [],
				token: localStorage.getItem('access_token'),
				roleid: localStorage.getItem('RoleId'),
				Id: localStorage.getItem('Id'),
				pageSize: 5,
				pageIndex: 1,
				pageTotal: '',
				editVisible: false,
				isdisabled: false,

				kuaipingList: [{
						Id: 1,
						Name: '普通快评'
					},
					{
						Id: 2,
						Name: '加急快评'
					}
				],
				startTime: '', //开始时间
				endTime: '', //结束时间
				stateList: [],
				bill: '',
				billId: '',
				upResName: '',
				upResName2: '',
				treeList: [],
				treeList2: [],
				defaultProps: {
					children: 'children',
					label: 'Name',
				},
				defaultProps2: {
					children: 'children',
					label: 'Name',
				},
				fillist: [],
				isphoto: false,
				photoList1: '',
				photoList2: '',
				serList: [],
				catList: []
			}
		},
		created() {
			this.getser()
			this.getcat()
			this.getGoodsList()
		},
		methods: {
			buildTree(arr, ParentId) {
				let tree = [];
				arr.map((item) => {
					if (item.ParentId === ParentId) {
						item.children = this.buildTree(arr, item.Id);
						tree.push(item);
					}
				});
				return tree;
			},
			//获取全部系列
			getser() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetSeries?name=" + '',
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					console.log(res.data.Data)
					this.serList = res.data.Data
				})
			},
			//获取全部分类
			getcat() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCategories?name=" + '',
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					console.log(res.data.Data)
					this.catList = res.data.Data
				})
			},
			deleGoods(row) {
				console.log(row.Id)
				this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "DeleteCollectiblesPool?Id=" + row.Id,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getGoodsList()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//查看商品照片
			lookPhoto(row) {
				console.log(row)
				this.photoList = []
				this.title = '查看商品照片'
				this.showphoto = true
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCollectiblesPhotos?biilId=" + row.BillId +
						'&collectiblesId=' + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						console.log(res.data.Data)
						res.data.Data.forEach((x) => {
							this.photoList.push(x)
						})
					}
				})
			},
			handleNodeClick(data) {
				this.upResName = data.Name
				this.ruleForm.SerieId = data.Id
			},
			handleNodeClick2(data) {
				this.upResName2 = data.Name
				this.ruleForm.CategoryId = data.Id
				console.log(data)
			},
			handleClear(obj) {
				// 将选择器的值置空
				if (obj == 'class') {
					this.upResName2 = ''
					this.ruleForm.CategoryId = ''
				} else {
					this.upResName = ''
					this.ruleForm.SerieId = ''
				}

			},
			//获取订单状态
			getstate() {
				axios({
					method: 'get',
					url: this.$store.state.url + "GetBillState",
				}).then((res) => {
					this.stateList = res.data.Data
				})
			},
			//获取全部会员
			getmember() {
				var token = this.token
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUsers?roleId=" + 'be4e45c7-03cc-45ee-8f00-49c3665819ca' +
						'&pageSize=999999',
					headers: {
						"Authorization": "bearer " + token + ""
					},
				}).then((res) => {
					this.memberList = res.data.Data
				})
			},
			//获取全部经销商
			getdistributor() {
				var token = this.token
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUsers?roleId=" + 'a591fe1e-7da8-4124-8912-b5af5282d57a' +
						'&pageSize=999999',
					headers: {
						"Authorization": "bearer " + token + ""
					},
				}).then((res) => {
					this.distributorList = res.data.Data
				})
			},
			//获取商品列表
			getGoodsList() {
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + 'GetCollectiblesStatistics?pageSize=' + this.pageSize +
						'&pageIndex=' + pageIndex + '&QRFont=' + this.QRFont + '&categoryId=' + this.categoryId +
						'&seriesId=' + this.seriesId,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.pageTotal = res.data.Count
					console.log(res.data.Data)
					this.goodsList = res.data.Data
					this.goodsList.forEach((x) => {
						if (x.Star == 1) {
							x.isStar = '是'
						} else {
							x.isStar = '否'
						}

						axios({
							method: 'get',
							url: this.$store.state.pcurl + "GetCollectiblesPhotos?biilId=" + x
								.BillId + '&collectiblesId=' + x.Id,
							headers: {
								"Authorization": "bearer " + this.token + ""
							},
						}).then((res) => {
							console.log(res.data.Data)
							res.data.Data.forEach((y) => {
								if (y.State == 1) {
									x.frontPhoto = y.Url
								} else {
									x.backPhoto = y.Url
								}
							})
						})
					})
				})
			},
			//监听时间变化
			changeTime() {
				let start = JSON.stringify(this.value2[0])
				let end = JSON.stringify(this.value2[1])
				this.startTime = JSON.parse(start).replace(/T|\.\d{3}Z/g, " ")
				this.endTime = JSON.parse(end).replace(/T|\.\d{3}Z/g, " ")
				console.log(this.startTime, this.endTime)
			},
			//搜索
			handleSearch() {
				this.pageIndex = 1
				this.billId = this.bill
				this.getGoodsList()
			},
			handlePageChange(val) {
				this.pageIndex = val
				this.getGoodsList()
			},
			//查看
			handleClick(row) {
				console.log(row)
				this.title = '查看商品'
				this.isdisabled = true
				this.editVisible = true
				this.ruleForm = row
			},
			//保存编辑
			saveEdit(ruleForm) {}
		}
	};
</script>

<style scoped>
	.el-select {
		width: 300px;
		margin-right: 10px;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	:deep(.el-upload) {
		width: 56px;
		height: 32px;
		border: none;
		line-height: 0;
	}

	:deep(.el-upload-list) {
		height: 0px !important;
	}

	:deep(.el-form-item__label) {
		width: 120px !important;
	}

	:deep(.el-form-item__content) {
		margin-left: 120px !important;
	}

	.listPhoto {
		width: 514px;
		height: 350px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
	}

	.xiaoshi {
		display: none;
	}
	.img{
		border-radius: 5px;
	}
	.el-image__inner{
		border-radius: 5px;
	}
</style>